export default __webpack_public_path__ + "static/media/coppiceoftheheart.e5b31afe.jpg";